import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>DIV Maker © arturowsky 2021</p>
    </footer>
  );
};

export default Footer;
